import {
  Component,
  inject,
  ElementRef,
  ViewChild,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyClient } from '../../../models/companyClients';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { CompanyClientService } from 'src/app/shared/services/company-client.service';

@Component({
  selector: 'app-company-client',
  imports: [
    ButtonModule,
    FormsModule,
    MultiSelectModule,
    TranslocoPipe,
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
  ],
  templateUrl: './company-client.component.html',
})
export class CompanyClientComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @ViewChild('clientInput') clientInput!: ElementRef<HTMLInputElement>;
  addClientMode: boolean = false;
  companyClientService = inject(CompanyClientService);

  newClientName: string = '';

  get clients(): CompanyClient[] {
    return this.companyClientService.companyClients();
  }

  ngOnInit() {
    this.companyClientService.loadClients();
  }

  showAddClient() {
    this.addClientMode = true;
    setTimeout(() => this.clientInput?.nativeElement.focus(), 0);
  }
  closeAddClient() {
    this.newClientName = '';
    this.addClientMode = false;
  }

  createClient() {
    this.companyClientService.createClient(this.newClientName).subscribe({
      next: () => {
        this.closeAddClient();
      },
      error: (err) => console.error(err),
    });
  }
}
